export default function Step({ number, title, description }) {
  return (
    <div style={{
      background: 'var(--bg-tertiary)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--spacing-xl)',
      border: '1px solid var(--border)',
      textAlign: 'center',
      position: 'relative'
    }}>
      <div style={{
        position: 'absolute',
        top: '-20px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '40px',
        height: '40px',
        background: 'var(--accent)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.25rem',
        fontWeight: '700',
        color: 'var(--text-primary)'
      }}>
        {number}
      </div>
      <h3 style={{
        marginTop: 'var(--spacing-lg)',
        marginBottom: 'var(--spacing-md)',
        color: 'var(--text-primary)'
      }}>
        {title}
      </h3>
      <p style={{
        color: 'var(--text-secondary)',
        margin: 0
      }}>
        {description}
      </p>
    </div>
  )
} 